import React, { useEffect, useRef } from 'react';
import { useLoading } from '../context/LoadingContext';
import gsap from 'gsap';

const ExperienceLoader = () => {
    const { isLoading } = useLoading();
    const containerRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ repeat: -1, yoyo: true });

        // "Breathing" animation for the text/symbol
        tl.to(textRef.current, {
            opacity: 0.3,
            duration: 1.5,
            ease: "sine.inOut"
        });

        return () => {
            tl.kill();
        };
    }, []);

    useEffect(() => {
        if (!isLoading) {
            // Exit animation
            gsap.to(containerRef.current, {
                opacity: 0,
                duration: 1.5,
                ease: "power2.inOut",
                display: "none",
                onComplete: () => {
                    // Optional: fire an event or signal that the scene is fully interactive
                }
            });
        }
    }, [isLoading]);

    return (
        <div
            ref={containerRef}
            className="fixed top-0 left-0 w-full h-full bg-black z-[9999] flex justify-center items-center pointer-events-none"
        >
            <div className="flex flex-col items-center">
                {/* 
            Design choice: Minimalist, "Apple-like" typography. 
            Not a spinner. Just a presence.
         */}
                <div
                    ref={textRef}
                    className="text-gray-300 font-light text-2xl tracking-widest uppercase opacity-80"
                    style={{ fontFamily: "'Inter', sans-serif" }} // Assuming font availability or default sans
                >
                    iPhone 16 Pro
                </div>
            </div>
        </div>
    );
};

export default ExperienceLoader;
